import { render } from "./AnswerCheck.vue?vue&type=template&id=04b4b1ec"
import script from "./AnswerCheck.vue?vue&type=script&lang=js"
export * from "./AnswerCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__